<template>
	<div id="churchsInputComponent">		
		<div style="position: relative" class="mb-3">
			<div class="form-floating mb-3">
				<input class="form-control form-control-sm rounded-2" :id="idRandom" placeholder="ej: central"
					onfocus="this.select()"
					v-model="searchInput" :disabled="!(listChurchs.length > 0)"
					@blur="blur"
					@focus="focusInput=true"
					@keyup="keyupLocal($event)">
				<label :for="idRandom">
					<small id="emailHelp" class="form-text text-muted" @click="getAllChurchsLocal" ref="getChurchs" v-show="searchingChurch">
						<i class="spinner-border" style="width: 16px; height: 16px"></i>
						<i>Buscando iglesias . . .</i>
					</small>
					<small id="emailHelp" class="form-text text-muted" v-show="(!searchingChurch && listChurchs.length > 0)">
						<i>Escriba y seleccione la iglesia de la lista </i>
						<i class="fa-solid fa-check text-success" v-if="data.id > 0" :title="'Código seleccionado: ' + data.id"></i>
						<i class="fas fa-exclamation-triangle text-warning" v-else title="No ha seleccionado un item de la lista"></i>
					</small>
				</label>
			</div>
			<button @click="clear" v-show="false" ref="clear">Limpiar</button>
			<ul class="list-result-input float-start" v-show="listChurchsSearch.length > 0 && searchInput.length > minShow && focusInput">
				<li v-for="(item, index) in listChurchsSearch" :key="index" @click="selectedChurch(item)">
					<div>
						<b>{{item.type_church.name}} {{item.name}}</b> - Distrito: {{item.district.name}}
					</div>
					<small>{{item.entity.name}}</small>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosSystem from '@/mixins/axiosSystem.js'
	import church from '@/mixins/church.js'
	
	export default {
		name: 'ChurchsInputComponent',
		mixins: [axiosSystem, mixin, church],
        props: ['searchChurch', 'url'],
		data () {
			return {
				data: {
					id: 0,
					string: '',
					item: {}
				},
				searchInput: '',
				minShow: 3,
				searching: false,
				focusInput: false,
				idRandom: ''
			}
		},
		computed: {
			listChurchsSearch() {
                let listChurchs = []
				if(this.searchInput.length > this.minShow) {
					listChurchs = this.listChurchs.filter(c => c.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1)
				}
                return listChurchs
			}
		},
		methods: {
            initComponentLocal() {
				this.idRandom = this.generateString(8)
				if(this.searchChurch) {
					this.getAllChurchsLocal()
				}
			},
			clear() {
				this.searchInput = ''
				this.clearData()
			},
			clearData() {
				this.data.string = ''
				this.data.id = 0
				this.data.item = {}
				this.$emit('actionSelectItem', this.data)
			},
			blur() {
				setTimeout(() => {
					this.focusInput = false
				}, 300)
			},
			getAllChurchsLocal() {
				if(this.listChurchs.length == 0) {
					this.getAllChurchs()
				}
			},
			getAllChurchsResultLocal(response){ 
			},
			keyupLocal(event) {
				if(this.data.id > 0) {
					this.clearData()
				}
			},
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'getAllChurchsResult': this.getAllChurchsResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			selectedChurch(item) {
                this.data.string = item.type_church.name + ' ' + item.name + ' - Distrito: ' + item.district.name + ' (' + item.entity.synthetic + ')'
                this.data.id = item.id
				this.data.item = item
				this.searchInput = item.type_church.name + ' ' + item.name + ' - Distrito: ' + item.district.name + ' (' + item.entity.synthetic + ')'
				this.$emit('actionSelectItem', this.data)
			},
		},
		mounted () {
            this.initComponentLocal()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.list-result-input {
	list-style: none;
	padding: 0px;
	margin-top: -19px;
	border: 1px solid #ccc;
	background-color: white;
	position: absolute;
	z-index: 1;
	width: 100%;
	box-shadow: 1px 1px #ccc;
}
.list-result-input>li {
	padding: 5px 10px;
	border-bottom: 1px solid #ddd;
}
.list-result-input>li:hover {
	background: #5bc0de;
	color:#fff;
	cursor: pointer;
}

</style>
